/**
 * @module Helpers/Cart
 * @desc Cart Helpers
 */

import type { Cart } from 'core/domains';

/**
 * Function responsible for updating the quantity of the item
 *
 */

export function cartData(state: Cart, code: Cart['deleteConfirmation']['data']['productCode']) {
  const { data } = state;
  const availableItemsIndex = data?.pointsPrograms?.findIndex((item, index) => {
    // eslint-disable-next-line no-prototype-builtins
    if (item.hasOwnProperty('availableItems')) {
      return index - 1;
    }

    return -1;
  });

  const pointsPrograms =
    availableItemsIndex >= 0
      ? data?.pointsPrograms[availableItemsIndex]?.availableItems?.find(
          ({ productCode }) => productCode === code,
        )
      : null;

  return {
    data: data.items.find(({ productCode }) => productCode === code) || pointsPrograms,
  };
}
